import React from 'react';
export function CheckIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "var(--icon-color)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.25",
    d: "m19.875 6.75-10.5 10.5L4.125 12"
  }));
}